import React, { ReactElement } from 'react';
import { MonitoringSchedule } from 'src/context/apiState';
import { ClientSideTable } from './ClientSideTable';
import { Link } from './Link';

export const MonitoringScheduleTable = ({
  loading,
  data,
  error,
}: {
  loading: boolean;
  data: MonitoringSchedule[] | null;
  error: Error | null;
}): ReactElement => {
  const columns = [
    {
      header: 'Id',
      id: 'id',
      width: 300,
      cell: (item: MonitoringSchedule) => (
        <Link to={`./monitoringSchedules/${item.id}/dataQualityMetrics`}>
          {item.id}
        </Link>
      ),
    },
    {
      header: 'Name',
      id: 'monitoringScheduleName',
      cell: (item: MonitoringSchedule) => item.monitoringScheduleName,
    },
    {
      header: 'Region',
      id: 'monitoringScheduleArn',
      cell: (item: MonitoringSchedule) => (
        <p>{item.monitoringScheduleArn || 'Not available.'}</p>
      ),
    },
    {
      id: 'createdDate',
      header: 'Created Date',
      cell: (item: MonitoringSchedule) => {
        const date = new Date(parseInt(item.createdDate) * 1000);
        return date.toUTCString();
      },
      sortingField: 'createdDate',
    },
    {
      id: 'updatedDate',
      header: 'Updated Date',
      cell: (item: MonitoringSchedule) => {
        const date = new Date(parseInt(item.updatedDate) * 1000);
        return date.toUTCString();
      },
      sortingField: 'updatedDate',
    },
  ];

  return (
    <ClientSideTable
      error={error}
      loading={loading}
      title="Monitoring Schedule"
      emptyText="No monitoring schedule found."
      data={data || []}
      columnDefinitions={columns}
    />
  );
};
